import React from 'react'
import classNames from 'classnames'
import { makeStyles } from '@mui/styles'
import SVGIcon from '../../svg-icon/svg-icon'
import TextInput from './text-input'
import PropTypes from 'prop-types'

const TextInputWithIcon = (props) => {
  const classes = useStyles()
  const { className, name, value, onChange, onIconClick, icon, label, ...rest } = props
  const textInputClasses = classNames(classes.textInput, className)

  return (
    <div className={classes.wrapper}>
      <TextInput
        name={name}
        label={label}
        value={value || ''}
        customClass={textInputClasses}
        onChange={onChange}
        {...rest}
      />
      <div className={classes.iconWrapper} onClick={onIconClick}>
        <SVGIcon customClass={classes.icon} width='18px' height='18px' svg={icon} />
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  iconWrapper: {
    cursor: 'pointer',
    display: 'flex',
    height: 45,
    width: 45,
    justifyContent: 'center',
    alignItems: 'center',
    border: theme.border,
    borderLeft: 0,
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
  },
  icon: {
    fill: theme.primary,
  },
  wrapper: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  textInput: {
    '& input': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
}))

TextInputWithIcon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onIconClick: PropTypes.func,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string,
}
TextInputWithIcon.defaultProps = {
}
export default TextInputWithIcon
